import { useState } from 'react';

export const NAV_COLLAPSED_STORAGE_KEY = 'tailoring-crm:nav-collapsed';

/**
 * Whether the desktop sidebar's section column is folded away, leaving only the icon rail.
 *
 * A preference of this browser, not of the account: how much room a screen can spare depends
 * on the screen. It is never flipped for the owner — collapsed stays collapsed on every page
 * until they open it again.
 */
export function useNavCollapsed(): { collapsed: boolean; toggle: () => void } {
  const [collapsed, setCollapsed] = useState(() => {
    if (typeof window === 'undefined') return false;

    try {
      return window.localStorage.getItem(NAV_COLLAPSED_STORAGE_KEY) === '1';
    } catch {
      return false;
    }
  });

  const toggle = (): void => {
    setCollapsed((current) => {
      const next = !current;

      try {
        window.localStorage.setItem(NAV_COLLAPSED_STORAGE_KEY, next ? '1' : '0');
      } catch {
        // Private browsing can deny storage. The in-session toggle still works.
      }

      return next;
    });
  };

  return { collapsed, toggle };
}
